import React from "react";
import swal from "sweetalert";

function DeleteButton({ id, deleteProducto, setProductos }) {
  function confirmDelete(id) {
    swal({
      title: "Eliminar Producto?",
      icon: "error",
      buttons: {
        cancel: "Cancelar",
        catch: "Eliminar",
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteProducto(id).then(() => {
          swal("Producto eliminado", {
            button: false,
            icon: "success",
            timer: "1500",
          });
          setProductos((prevState) =>
            prevState.filter((producto) => producto.id !== id)
          );
        });
      }
    });
  }

  return (
    <button
      className="btn btn-danger btn-sm btn-block m-1"
      onClick={() => confirmDelete(id)}
    >
      Eliminar
    </button>
  );
}

export default DeleteButton;
